module.exports = __webpack_public_path__ + "assets/img/hov_btn_TapTap-072e1d01.png";